module.exports = __webpack_public_path__ + "range-bg.39f86abeddeee41004de.png";


//////////////////
// WEBPACK FOOTER
// /Users/avihayev/Phone-Plans/Lading Page/landing-page-web/src/assets/img/range-bg.png
// module id = ../../../../../src/assets/img/range-bg.png
// module chunks = styles